import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-617c67b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "入力内容の確認")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text" }, [
  /*#__PURE__*/_createTextVNode(" この内容でよろしければ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「この内容で決定する」を押してください ")
], -1))
const _hoisted_4 = { class: "profile_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "就業状況", -1))
const _hoisted_6 = { class: "profile_item_value" }
const _hoisted_7 = { class: "profile_item_value_text" }
const _hoisted_8 = { class: "profile_item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "経験社数", -1))
const _hoisted_10 = { class: "profile_item_value" }
const _hoisted_11 = { class: "profile_item_value_text" }
const _hoisted_12 = { class: "profile_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "社会人経験年数", -1))
const _hoisted_14 = { class: "profile_item_value" }
const _hoisted_15 = { class: "profile_item_value_text" }
const _hoisted_16 = { class: "profile_item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "マーケティング・デジタル・クリエイティブ領域の経験", -1))
const _hoisted_18 = { class: "profile_item_value" }
const _hoisted_19 = { class: "profile_item_value_text" }
const _hoisted_20 = { class: "profile_item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "ポートフォリオサイトのURL", -1))
const _hoisted_22 = { class: "profile_item_value" }
const _hoisted_23 = { class: "profile_item_value_text" }
const _hoisted_24 = { class: "profile_item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "ポートフォリオサイトのID", -1))
const _hoisted_26 = { class: "profile_item_value" }
const _hoisted_27 = { class: "profile_item_value_text" }
const _hoisted_28 = { class: "profile_item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "ポートフォリオサイトのパスワード", -1))
const _hoisted_30 = { class: "profile_item_value" }
const _hoisted_31 = { class: "profile_item_value_text" }
const _hoisted_32 = { class: "profile_button_register" }
const _hoisted_33 = { class: "profile_button_modify" }

import { ref, computed, watchEffect } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import { MasterDataWkStatus } from '@/api/masterDataEndpoint';
import alertOnReload from '@/utils/alertOnReload';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeConfirmView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const expcompNum: string = store.getters['resumeCompany/expcompNum'];
const expYearNum: string = store.getters['resumeCompany/expYearNum'];
const expMonthNum: string = store.getters['resumeCompany/expMonthNum'];
const adlandexpFlg: boolean = store.getters['resumeCompany/adlandexpFlg'];
const wkStatusId: number = store.getters['resumeCompany/wkStatusId'];
const wkStatusArray: MasterDataWkStatus[] = store.getters['resumeCompany/wkStatusArray'];
const portfolioSiteUrl: string = store.getters['resumeCompany/portfolioSiteUrl'];
const portfolioSiteId: string = store.getters['resumeCompany/portfolioSiteId'];
const portfolioSitePass: string = store.getters['resumeCompany/portfolioSitePass'];

const wkStatus = computed(() => {
  return wkStatusArray.filter((i) => i.code === wkStatusId)[0]?.name;
});

const adlandexp = computed(() => {
  return adlandexpFlg ? 'あり' : 'なし';
});

const isLoading = ref(false);

const isError = computed(() => {
  return !expcompNum || !expYearNum || !expMonthNum || adlandexpFlg === null || !wkStatusId || !wkStatusArray;
});

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e31', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e31' });
  }
};

watchEffect(() => {
  if (isError.value) {
    transitionPreviousPage();
  }
});

const save = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('resumeCompany/updateResumeCompany');
    store.dispatch('toasts/appendTimeToast', { label: '社会人経験を更新しました' });
    if (route.query.ref === 'e') {
      router.push({ name: 'e30', query: { ref: 'e' } });
    } else {
      router.push({ name: 'n30' });
    }
  } catch (error) {
    store.dispatch('toasts/appendTimeToast', { label: '社会人経験の更新に失敗しました', duration: null });
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(wkStatus)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(expcompNum)) + "社", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(expYearNum)) + "年" + _toDisplayString(_unref(expMonthNum)) + "ヵ月", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(adlandexp)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(portfolioSiteUrl)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(portfolioSiteId)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(portfolioSitePass)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(BaseButton, {
          theme: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [
            _createTextVNode("この内容で決定する")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("修正する")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})